import React from 'react';
import PropTypes from 'prop-types';

import { buildDescription } from 'components/IndividualValidationResult';

const ValidationResultCell = ({ dataKey, data, className }) => {
  const getItemClass = (item) => {
    if (item.code) {
      if (item.code.indexOf('WRN') !== -1) {
        return 'red-flag';
      }
      if (item.code.indexOf('REC') !== -1) {
        return 'recommendation';
      }
    }
    return '';
  };

  return (<div className={ className }>
    { data != null && data[dataKey] != null && data[dataKey].length === 0 && <span>N/A</span> }
    { data[dataKey] != null && data[dataKey].length !== 0 && <ul>
      { data[dataKey].sort(({ code: a }, { code: b }) => {
        if (a.indexOf('WRN') === 0 && b.indexOf('REC') === 0) {
          return -1;
        }
        if (b.indexOf('WRN') === 0 && a.indexOf('REC') === 0) {
          return 1;
        }
        return 0;
      }).map(item => (item != null
        && <li
          key={ item.key }
          className={ getItemClass(item) }
        >
          { buildDescription(item) }
          &nbsp;({ item.code })</li>
      )) }
    </ul> }
  </div>);
};

ValidationResultCell.propTypes = {
  dataKey: PropTypes.string,
  data: PropTypes.shape(),
  className: PropTypes.string
};

ValidationResultCell.defaultProps = {
  dataKey: null,
  data: null,
  className: null
};

export default ValidationResultCell;
